<template>
  <div>
    <v-overlay
      absolute
      :value="this.value"
    >  </v-overlay>
    <v-navigation-drawer
      :width="$vuetify.breakpoint.xs ? '90%' : $vuetify.breakpoint.sm ? '60%' : $vuetify.breakpoint.md ? '50%' : '30%' "
      fixed left v-model="bActiveNavigator" hide-overlay stateless
      >
      <template v-slot:prepend>
        <div class="pa-1 ma-0 cont-header d-flex">
          <h2 class="text-medium text-max text-primary ma-0 pa-0">Filtros Detallados</h2>
          <v-btn 
            class="ml-auto" 
            @click="onEventoNavigation" 
            small
            icon>
            <v-icon color="primary" size="25px">fa-times-circle</v-icon>
          </v-btn>
        </div>
      </template>
       <v-card elevation="0">
        <v-card-text class="pa-1">
          <v-row class="no-gutters d-flex justify-center align-end">
            <v-col cols="12" class="py-1 ma-0 under-sec-flat">
              <div class="cont-select-filtros">
                <span class="text-primary">Seleccione los campos de filtrado</span>
                <v-select
                  v-model="aFiltrosActivos"
                  :items="cmpCamposFilto"
                  item-value="key"
                  small-chips
                  multiple
                  outlined
                  dense
                  hide-details
                  x-small
                  :menu-props="{
                  closeOnContentClick: bToggleSelect,
                  maxHeight: 404
                  }"
                >
                <template v-slot:append-item>
                  <v-divider class="mb-2"></v-divider>
                  <v-list-item class="append">
                    <v-list-item-content>
                      <v-btn
                          color="btncolor"  class="mx-auto mx-1"
                          small dark
                          @click="bToggleSelect = true"
                          >
                          Aceptar
                        </v-btn>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                </v-select>
            </div>
            </v-col>  
            <!-- :key="index + onKeyRefreshj" -->
            <v-col cols="12 pa-0"
              v-for="(Filtro,index) in cmpaFiltrosActivos" :key="'filtro'+index" class="pb-1">
              <component
                :key="nKeyrefresReload"
                :is="Filtro.tipo"
                :title="Filtro.text"
                :indice="Filtro.value"
                :campo="Filtro.value"
                :inner="Filtro.InnerJoin"
                :bSubdominioTemporal="bSubdominioTemporal"
                v-model="oParamsFiltro[Filtro.value]"
                @remove="onRemove"
              ></component>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <template v-slot:append> 
        <div xs12 class="pa-1 d-flex justify-center align-center text-center cont-footer">
          <!-- filtradoEstateComponente -->
          <v-tooltip top v-if="!aFiltrosActivos.length == 0">
            <template v-slot:activator="{ on }">            
              <v-btn v-if="!aFiltrosActivos.length == 0"
                v-on="on"
                color="btncolor"
                @click="onEliminarFiltros"
                outlined
                :small="$vuetify.breakpoint.xs"
                dark
                class="mx-1 mx-auto"
                >
                Eliminar
                <v-icon small right>fa-trash-alt</v-icon>
              </v-btn>
            </template>
            <span>Eliminar Filtros</span>
          </v-tooltip>
          <v-btn
            :disabled="aFiltrosActivos.length == 0"
            color="btncolor"
            class="mx-auto mx-1"
            dark
            :small="$vuetify.breakpoint.xs"
            @click="onEjecutar">
            Ejecutar Filtros
            <v-icon dark small right>fa-play</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
   
  </div>
</template>
<script>
import texto from '@/components/Grid/Filter_Component/Texto.vue'
import numero from '@/components/Grid/Filter_Component/Numero.vue'
import datetext from '@/components/Grid/Filter_Component/DateText.vue'
import selector from '@/components/Grid/Filter_Component/Selector.vue'
import select_user from '@/components/Grid/Filter_Component/Select_user.vue'
import campoSiNo from '@/components/Grid/Filter_Component/CampoSiNo.vue'
import campoSwitch from '@/components/Grid/Filter_Component/CampoSwitch.vue'

import campoBuenoRegularNA from '@/components/Grid/Filter_Component/CampoBuenoRegularNA.vue'
import { mapGetters } from 'vuex'

export default {
  name:"FilterSecction",
  props:{
    aHeaders: {
      type: Array,
    },
    value: {   // Se controla si se ve o no el filtro
      type: Boolean,
      default: false   
    },
    bSubdominioTemporal:{ //Indica que se activa puente con subdominio temporal
      type: Boolean,
      default: false
    },
  },
  components:{
    texto,
    numero,
    datetext,
    selector,
    select_user,
    campoSiNo,
    campoSwitch,
    campoBuenoRegularNA
  },
  data() {
    return {
      aFiltrosActivos   : [],  // No se emite
      oParamsFiltro     : {},  // se emite en ejecutarFiltro
      onKeyRefreshj     : 0,
      aNombreFiltros    : [],  // se emite en listadoFiltros
      bToggleSelect     : false,
      nKeyrefresReload  : 0,
      bActiveNavigator  : false,
    }
  },
  async mounted () {


    if(this.getsBeforePath === 'FormDinamicoReporte'){
      this.aNombreFiltros = await this.getaListadoFiltrosFinal        
      this.aFiltrosActivos = await this.getaFiltrosActivos
      this.oParamsFiltro = await this.getoParamsFiltro
      this.nKeyrefresReload++
    }
    
    if(this.getbCargarStorage){
      this.aNombreFiltros = await this.getaListadoFiltrosFinal        
      this.aFiltrosActivos = await this.getaFiltrosActivos
      this.oParamsFiltro = await this.getoParamsFiltro
      this.nKeyrefresReload++
      this.onEjecutar()
      this.onEventoNavigation()
      this.$emit('listadoFiltros', this.aNombreFiltros)
      // this.$store.dispatch('filterSeccion/save_bCargarStorage', false)  // se reinicia la variable
    }


  },
  methods: {
    onEventoNavigation(){
      this.$emit('input', false)
    },
    onRemove(indice){
      this.aFiltrosActivos.splice(this.aFiltrosActivos.indexOf(indice),1)
      // this.aFiltro = {}
      delete this.oParamsFiltro[indice]
      this.$store.dispatch('filterSeccion/delete_aInfoFiltrada', indice)
      this.onKeyRefreshj++
    },
    onEjecutar(){
      this.$emit('ejecutarFiltro',this.oParamsFiltro)
      this.$emit('input', false)
    },
    onEliminarFiltros(){
      this.$store.dispatch('filterSeccion/save_bCargarStorage', false)  // se reinicia la variable
      this.aFiltrosActivos = []
      this.oParamsFiltro = {}
      this.$emit('LimpiarFiltrosComponente')
    },

  },
  computed: {
    cmpaFiltrosActivos() {
      let filtros = []
      this.aHeaders.forEach( header =>{
        if(this.aFiltrosActivos.indexOf(header.value) >= 0){
          filtros.push(header)
        }
      })
      return filtros 
    },
    cmpCamposFilto() {
      let campos= []
      this.aHeaders.forEach( header =>{
          if(header.filtro == 1){
            let oCampos = {
              "key": header.value,
              "text": header.text
            };
            campos.push(oCampos)
          }
      })
      return campos
    },
    ...mapGetters('filterSeccion',[
      'getoParamsFiltro', 
      'getbFiltrarActive', 
      'getaListadoFiltrosFinal', 
      'getaFiltrosActivos', 
      'getbCargarStorage',
    ]),
    ...mapGetters(['getsBeforePath'])


  },
  watch: {
    cmpaFiltrosActivos(val){
      this.aNombreFiltros = val 

    },
    aFiltrosActivos() {
      this.$emit('aFiltrosActivos', this.aFiltrosActivos)
      this.onKeyRefreshj++
      this.$emit('listadoFiltros', this.aNombreFiltros)
      if(this.aFiltrosActivos.length === 0){
        this.$emit('LimpiarFiltrosComponente')
      }
    },
    value () {
      this.bActiveNavigator = this.value
    }

  },
}
</script>
<style lang="scss" scoped>
.contenedor-filtros{
  padding: 0px 0px!important;
}
.cont-header{
  border-bottom: solid 1px rgba($color: #152232, $alpha: 0.3);
  box-shadow: 0px 0px 4px rgba($color: #152232, $alpha: 0.9);
}
.cont-footer{
  border-top: solid 1px rgba($color: #152232, $alpha: 0.3);
  box-shadow: 0px 0px 4px rgba($color: #152232, $alpha: 0.9);
}
.append{
  position:sticky;
  bottom:0px;
  width:100%;
  display:flex;
  justify-content :center;
  background :white;
  box-shadow: 0px 0px 10px rgba($color: #152232, $alpha: 0.3);;
}
</style>